import React, {
  createContext, useCallback, useContext, useEffect, useState,
} from 'react';
import { useSelector } from 'react-redux';

// Components
import { isEmpty, isEqual } from 'underscore';
import { AngularContext } from 'react-app';
import { RecordingEvent, UploadEvents } from './live-session-card/live-session-card';
import MultipleLiveSessions from './multiple-live-sessions';

export const LiveSessionsContext = createContext(null);

type LiveSessionLectureComponentProps = {
  lectureComponent: any
  isEdit: boolean
  onSaveExpectations: (e: any) => void
  joinNow: (sessionId: number) => void
  uploadAttendeeList: (sessionId: number) => void
  uploadRecording: (sessionId: number, events: UploadEvents) => void
  editRecording: (sessionId: number, file: any, onSuccess: (recording: any) => void) => void
  removeRecording: (sessionId: number, onSuccess: () => void) => void
  delete: (sessionId: number) => void
  recordingEventCallback: (
    event: RecordingEvent,
    second: number,
    totalLength: number,
    lecturePageId: number,
    lectureComponentId: number,
    sessionId: number,
  ) => void
};

const LiveSessionLectureComponent = ({
  lectureComponent,
  ...restProps
}: LiveSessionLectureComponentProps) => {
  const { injectServices } = useContext(AngularContext);
  const [CurrentUserManager, $state] = injectServices(['CurrentUserManager', '$state']);
  const leSessions = useSelector(state => state.app.liveSessions.sessions);

  const { liveSession } = lectureComponent;
  const { sessions: initialSessions, isRegistrationEnabled } = liveSession;
  const [sessions, setSessions] = useState(initialSessions);
  const isAdmin = CurrentUserManager.isAdmin();

  const onDeleteSession = useCallback((sessionId) => {
    const newSessions = sessions.filter(session => session.id !== sessionId);
    setSessions(newSessions);
  }, [sessions]);

  useEffect(() => {
    if (!isEmpty(leSessions)) {
      const newSessions = sessions.map(session => leSessions[session.id] ?? session);
      if (!isEqual(newSessions, sessions)) {
        setSessions(newSessions);
      }
    }
  }, [leSessions]);

  return (
    <LiveSessionsContext.Provider value={{
      ...restProps,
      onSuccessDeletion: onDeleteSession,
      sessions,
      lectureComponent,
      isAdmin,
      catalogId: $state.params.catalogId,
      isRegistrationEnabled,
      mainDescription: liveSession.mainDescription,
    }}
    >
      <MultipleLiveSessions />
    </LiveSessionsContext.Provider>
  );
};

export default LiveSessionLectureComponent;
